import {
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig
} from 'axios';

import {env} from '@/config';

import {ConsoleLogger} from '@/services/logger';
import {LogLevel} from '@/constants';

const {SERVER_ENDPOINT, ENVIRONMENT} = env;

const __DEV__ = ENVIRONMENT !== 'production';

const DEBUG: boolean | 'INFO' = true;

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new ConsoleLogger(
  DEBUG === true ? LogLevel.DEBUG : LogLevel.INFO
);

const requestLogEnabled = false;

export const logRequest = (
  url: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: AxiosRequestConfig<any> = {}
) => {
  if (__DEV__ && DEBUG === true && requestLogEnabled) {
    const {method = 'GET', data, headers} = config;
    const auth = headers?.Authorization ? true : false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {_retry: retry = false} = config as AxiosRequestConfig<any> & {
      _retry?: boolean;
    };

    logger.debug(
      `${method.padEnd(6, ' ')}${auth ? '' : '[UNAUTH]'}${
        retry ? '[RETRY]' : ''
      } ${url}`,
      data
    );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logResponse = (response: AxiosResponse<any, any>) => {
  if (__DEV__ && DEBUG === true) {
    const {config, status, data} = response;
    const {
      method = 'GET',
      url = 'missing',
      _retry: retry = false
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } = config as InternalAxiosRequestConfig<any> & {_retry?: boolean};
    const auth = config.headers.Authorization ? true : false;

    let parsedRequestData = config.data;

    if (config.data) {
      try {
        parsedRequestData = JSON.parse(config.data);
      } catch (e) {
        logger.warn('Error parsing request data', e);
      }
    }
    logger.debug(
      `${method.padEnd(6, ' ')}[${status}]${auth ? '' : '[UNAUTH]'}${
        retry ? '[RETRY]' : ''
      } ${SERVER_ENDPOINT}/${url}`,
      {
        request: parsedRequestData,
        response: data
      }
    );
  }
};
